import type { CurrencyCode, Navigation } from '@noths/polaris-dev-ts-types';
import type { SerializedError } from '@reduxjs/toolkit';

import type { ReduxProductsCategory } from 'src/redux/products/types/reduxProductsCategory';
import type { Facet } from 'src/redux/productsQuery/types/Facet';
import type { SortOption } from 'src/redux/productsQuery/types/SortOption';
import type { Partner } from 'src/types/partner';
import type { Product } from './types/Product';

export enum TriggerName {
  CHANGE_FACETS = 'changeFacets',
  CHANGE_SORT = 'changeSort',
  LOAD_MORE_PRODUCTS = 'loadMoreProducts',
  LOAD_PREVIOUS_PRODUCTS = 'loadPreviousProducts',
}

export interface ProviderMetadata {
  filter: string;
  pageCategories: string[];
}

// return format of adapter
export interface RequestProductsActionProductsPayload {
  category: ReduxProductsCategory | null;
  currencyCode: CurrencyCode;
  errorCode?: string;
  errorMessage?: string;
  lastPageLoaded: number;
  navigation: Navigation[];
  partner?: Partner | null;
  perPage: number;
  products: Product[];
  productsReturnedCount: number;
  providerAttributionToken: string | null;
  providerMetadata: ProviderMetadata | null;
  term: string | null;
  totalPages: number;
  totalProducts: number;
}

// return format of requestProducts thunk; used in reducer
export interface RequestProductsActionPayload {
  facets?: Facet[];
  products?: RequestProductsActionProductsPayload;
  redirectUrl?: string;
  sortOptions?: SortOption[];
  triggerName?: TriggerName;
}

export interface ProductsState {
  category: ReduxProductsCategory | null;
  currencyCode: CurrencyCode;
  deliveryZone?: string;
  error?: SerializedError | null;
  initialProductPage?: number;
  lastPageLoaded: number | null;
  navigation: Navigation[];
  pageLoading: number | null;
  pages: Record<number, Product[]>;
  partner?: Partner;
  productsReturnedCount: number;
  providerAttributionToken: string | null;
  providerMetadata: ProviderMetadata | null;
  redirectUrl?: string;
  showFewResultsMessage?: boolean;
  totalPages: number;
  totalProducts: number;
}
